import Game from "../../../Game";
import { rootEventBus, EnumRootEventBus } from "../../../managers/RootEventBus";
import PlayAnimationButton from "./PlayAnimationButton";
import CancelAnimationButton from "./CancelAnimationButton";
import { Coord } from "../../../types/Interface";

export default class CircleAnimationButton{
  private Game = Game.getInstance();
  private PlayAnimationButton!: PlayAnimationButton;
  private CancelAnimationButton!: CancelAnimationButton;

  constructor(
		private infoSliderCoord: Coord,
		private runAnimations: () => void,
		private getDelayForStartAnim: () => number = () => 0,
	 ){
		this.addPlayAnimButton();
		this.addCancelAnimButton();
  }
  getAnimButtonCoord() {
    const dims = this.Game.getDim();
    if (dims.HEIGHT > dims.WIDTH) {
      return {
        x: dims.WIDTH / 2,
        y: dims.HEIGHT / 2 - 380
      }
    } else {
       return {
        x: this.infoSliderCoord.x,
        y: this.infoSliderCoord.y + 230
      }
    }
  }
	getScale(){
		const dims = this.Game.getDim();
		return dims.HEIGHT > dims.WIDTH ? 1.35 : 1;
	}

	addPlayAnimButton() {
		const handleFunc = () => {
			const startAnim = () => {
				rootEventBus.emit(EnumRootEventBus.startedCircleAnim);
				this.runAnimations();
				this.PlayAnimationButton.visible = false;
			}
			setTimeout(() => startAnim(), this.getDelayForStartAnim());
			rootEventBus.emit(EnumRootEventBus.closeSwitcher);
		};
		rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.PlayAnimationButton.visible = true);
	
		this.PlayAnimationButton = new PlayAnimationButton(handleFunc);
		Object.assign(this.PlayAnimationButton, this.getAnimButtonCoord());
		this.PlayAnimationButton.scale.set(this.getScale());
	}
	
	addCancelAnimButton() {
		const handleFunc = () => {
			rootEventBus.emit(EnumRootEventBus.cancelledCircleAnim);
			this.CancelAnimationButton.visible = false;
		}
		rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.CancelAnimationButton.visible = true);
		rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.CancelAnimationButton.visible = false);
	
		this.CancelAnimationButton = new CancelAnimationButton(handleFunc);
		this.CancelAnimationButton.visible = false
		Object.assign(this.CancelAnimationButton, this.getAnimButtonCoord());
		this.CancelAnimationButton.scale.set(this.getScale());
	}
}